import { connect } from 'react-redux';
import { ThreeDSecureAuthentModal } from './ThreeDSecureAuthentModal';
import { stripeRedirectUrlSelector, is3DSecureAuthentModalOpenSelector } from '../../../modules/Payment/selector';

const mapStateToProps = state => ({
  stripeRedirectUrl: stripeRedirectUrlSelector(state),
  isVisible: is3DSecureAuthentModalOpenSelector(state),
});

export default connect(mapStateToProps)(ThreeDSecureAuthentModal);
